/*
 * Copyright 2018 Teralytics
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { getDiffColorsRGBA } from '@flowmap.gl/core';
import * as React from 'react';
import Disc from './Disc';
var styles = {
    outer: {
        display: 'flex',
        flexDirection: 'column',
    },
    disc: {
        marginRight: 5,
    },
    item: {
        outer: {
            display: 'flex',
            flexDirection: 'row',
            padding: '3px 0',
            alignItems: 'center',
        },
        caption: {
            marginLeft: 2,
        },
    },
};
var DiffColorsLegend = function (props) {
    var size = 20;
    var colorsRGBA = getDiffColorsRGBA(props.colors);
    var pos = colorsRGBA.positive.locationCircles;
    var neg = colorsRGBA.negative.locationCircles;
    return (React.createElement("div", { style: styles.outer },
        React.createElement("div", { style: styles.item.outer },
            React.createElement(Disc, { size: size, inner: pos.inner, outer: pos.inner, outline: pos.inner }),
            React.createElement("div", { style: styles.item.caption }, props.positiveText || 'positive difference')),
        React.createElement("div", { style: styles.item.outer },
            React.createElement(Disc, { size: size, inner: neg.inner, outer: neg.inner, outline: neg.inner }),
            React.createElement("div", { style: styles.item.caption }, props.negativeText || 'negative difference'))));
};
export default DiffColorsLegend;
//# sourceMappingURL=DiffColorsLegend.js.map